module.exports = __webpack_public_path__ + "img/logo.dfc59cc0.png";